import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import { unionService } from '../../_services/union.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

class UnionSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      defaultValue: '',
      data: []
    }
  }

  componentWillMount() {
    this.getData()
  }

  getData() {
    unionService
      .getAll()
      .then(res => {
        // console.log(res.data)
        let data = res.data.map(elm => ({
          label: elm.name,
          value: elm.id,
          creditPayment: elm.creditPayment
        }))
        this.setState({ data: data, loading: false, isSubmitting: false })
      })
      .catch(error => {
        // console.log(error);
        this.setState({ loading: false })
      })
  }

  handleChange = e => {
    this.props.onChange(e.value, e.creditPayment)
  }

  render() {
    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0
      }),
      menuList: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0
      }),
      option: (provided, state) => ({
        ...provided,
        padding: 10
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#6d6d6d'
      }),
      control: provided => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f3f6ff',
        borderRadius: 10,
        height: 50,
        boxShadow: 'none',
        paddingRight: '12',
        border: 'none',
        marginBottom: 10
      }),
      indicatorSeparator: () => ({
        display: 'none'
      })
    }
    const simpleStyles = {
      menu: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0
      }),
      menuList: (provided, state) => ({
        ...provided,
        margin: 0,
        padding: 0
      }),
      option: (provided, state) => ({
        ...provided,
        padding: 10,
        fontSize: 12
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        color: '#6d6d6d'
      }),
      control: provided => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#fff',
        borderRadius: 0,
        height: 50,
        boxShadow: 'none',
        paddingRight: '12',
        border: 'thin solid #e9e9e9',
        marginBottom: 10,
        direction: 'rtl'
      }),
      indicatorSeparator: () => ({
        display: 'none'
      })
    }
    const { loading, data } = this.state
    const { disabled, required, sympleStyle } = this.props

    return (
      <div>
        {loading ? (
          <div className="text-input classSelectLoading">
            <div className="text-input-indicator">
              <div className="load">
                <div id="wrapperr">
                  <p>در حال بارگذاری ...</p>
                  <div id="loader" />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Select
            isDisabled={disabled}
            placeholder=""
            styles={sympleStyle ? simpleStyles : customStyles}
            options={data}
            onChange={this.handleChange}
            value={this.props.defaultValue}
            // className={required ? "select required" : "select"}
          />
        )}
      </div>
    )
  }
}
export default UnionSelect
